import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { application } from "globals/endpoints";

function UserMasterCell({ row }) {
  const [listOptions, setListOptions] = useState([]);

  useEffect(() => {
    application.post("/role/dropdownList").then((response) => {
      setListOptions(response.data.data);
    });
  }, []);

 const matchedRoles = listOptions && listOptions.filter((option) => {
   return (
     option.id !== null &&
     row.original.role &&
     row.original.role.includes(option.id)
   );
 });

  return (
    <>
      <MDTypography variant="caption" fontWeight="medium" color="text">
        {matchedRoles &&
          matchedRoles.map((role) => role.description).join(", ")}
      </MDTypography>
    </>
  );
}

export default UserMasterCell;
